import { useTranslation } from 'react-i18next';

// Returns the language i18next resolved for the active user selection.
export function useAppLocale(): string {
  const { i18n } = useTranslation();

  return i18n.resolvedLanguage ?? i18n.language;
}
